import { useGameStateContext } from 'app/src/game/GameStateContext';
import { useInstructionsArchiveContext } from 'app/src/game/InstructionsArchiveContext';
import { useLevelContext } from 'app/src/game/LevelContext';
import { useProgramStoreContext } from 'app/src/game/ProgramStoreContext';
import Modal from 'app/src/modals/Modal';
import * as React from 'react';
import { Link } from 'react-router-dom';

export default function YouWinModal(): React.ReactElement {
	const { gameStateStore } = useGameStateContext();
	const { getNextLevel } = useLevelContext();
	const { program } = useProgramStoreContext();
	const { instructionCounts } = useInstructionsArchiveContext();

	const usedInstructions = program.length;
	const remainingInstructions = Array.from(instructionCounts).reduce(
		(curr, next) => curr + next[1],
		0,
	);
	const totalInstructions = program.length + remainingInstructions;

	const totalStars = Array.from(gameStateStore.stars).length;

	const nextLevel = getNextLevel();

	return (
		<Modal className="YouWinModal">
			<div className="YouWinModal-screen">
				<h1 className="YouWinModal-title">Level Complete</h1>
				<div className="YouWinModal-stats">
					{usedInstructions}/{totalInstructions} Instructions
				</div>
				<div className="YouWinModal-stars">
					{new Array(totalStars).fill('').map((_, index) => (
						<div className="YouWinModal-star" key={`Star-${index}`} />
					))}
				</div>
			</div>
			<div className="YouWinModal-buttonContainer">
				<Link to="/" className="YouWinModal-button">
					Menu
				</Link>
				{nextLevel && (
					<Link to={`/level/${nextLevel}`} className="YouWinModal-button">
						Next
					</Link>
				)}
			</div>
		</Modal>
	);
}
